module.exports = __webpack_public_path__ + "static/media/rectangle-rounded.9230a498.svg";